import React from "react";
import "./Feedback.css";

const Feedback = () => {
  return (
    <div className="feedback-container">
      <iframe
        src="https://forms.gle/7SZhcazFKvavGYwJ9"
        title="VitStra Feedback"
        className="feedback-iframe"
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};

export default Feedback;